import { FE_LO_MIGRATE_CALLS_TO_LAYOUT_SERVICE_250617 } from "@faire/retailer-settings/FE_LO_MIGRATE_CALLS_TO_LAYOUT_SERVICE_250617";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { useEffect } from "react";

export const useSettingAndAssignMigrateToLayoutServiceEndpoints =
  (): boolean => {
    const assignSetting = useAssignSetting(
      FE_LO_MIGRATE_CALLS_TO_LAYOUT_SERVICE_250617
    );
    useEffect(() => {
      assignSetting();
    }, [assignSetting]);
    return useSetting(FE_LO_MIGRATE_CALLS_TO_LAYOUT_SERVICE_250617);
  };
